module.exports = __webpack_public_path__ + "img/wheel_LOW_win.ef370be9.png";